module.exports = __webpack_public_path__ + "static/media/wheel.42a5042d.png";